import React, { useEffect, useRef, useState } from "react";
import downloadIcon from "../../../../assets/register_assets/generatedForms/downloadIcon.png";
import "./GeneratedFormDownloadMenu.css";

const OPTIONS = [
  { key: "excel", label: "Excel", hint: "Default .xlsx" },
  { key: "pdf", label: "PDF", hint: "Converted document" },
  { key: "both", label: "Both", hint: "Excel + PDF in ZIP" },
];

/**
 * Same download icon — opens a compact format menu.
 * Click icon again (or outside) to close. Choosing an option triggers onSelect(format).
 */
function GeneratedFormDownloadMenu({
  onSelect,
  disabled = false,
  title = "Download",
  className = "",
  iconClassName = "generatedFormsDownloadicon",
  align = "right",
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setOpen((prev) => !prev);
  };

  const handlePick = (format) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
    if (typeof onSelect === "function") onSelect(format);
  };

  return (
    <span
      className={`gf-download-menu ${className} ${open ? "is-open" : ""} ${
        disabled ? "is-disabled" : ""
      }`}
      ref={rootRef}
    >
      <button
        type="button"
        className="gf-download-menu__trigger"
        title={title}
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={disabled}
        onClick={handleToggle}
      >
        <img className={iconClassName} src={downloadIcon} alt="Download" />
        <span className="gf-download-menu__caret" aria-hidden="true" />
      </button>

      {open && (
        <div
          className={`gf-download-menu__panel gf-download-menu__panel--${align}`}
          role="menu"
        >
          <div className="gf-download-menu__heading">Download as</div>
          {OPTIONS.map((opt) => (
            <button
              key={opt.key}
              type="button"
              role="menuitem"
              className={`gf-download-menu__option ${
                opt.key === "excel" ? "is-default" : ""
              }`}
              onClick={handlePick(opt.key)}
            >
              <span className="gf-download-menu__option-label">{opt.label}</span>
              <span className="gf-download-menu__option-hint">{opt.hint}</span>
            </button>
          ))}
        </div>
      )}
    </span>
  );
}

export default GeneratedFormDownloadMenu;
